<template>
  <div class="container">
    <div class="people" v-if="query">
      <div class="people-label">
        <i
          class="iconfont1 icon-user-wait"
          style="color: #3478f7; font-size: 17ypx; padding-right: 3px"
        ></i
        >就诊人：
      </div>
      <div class="people-text">{{ query.patientName }}</div>
    </div>
    <div class="detail" v-if="query">
      <div class="detail-label">预约科室：</div>
      <div class="detail-text">{{ query.deptName }}</div>
    </div>
    <div class="detail" v-if="query">
      <div class="detail-label">预约医生：</div>
      <div class="detail-text">{{ query.doctName }}</div>
    </div>
    <!-- <div class="detail">
      <div class="detail-label">就诊时间：</div>
      <div class="detail-text">{{ dateProp(query.ADM_DATE) }}</div>
    </div> -->
    <div class="pay-num" v-if="query">
      <div class="pay-num-label">付款金额</div>
      <div class="pay-num-text">￥{{ query.totCost }}</div>
    </div>
    <div class="btn-box" v-if="query">
      <van-button round type="info" size="large" @click="goPay"
        >立即付款</van-button
      >
    </div>
    <van-empty v-if="!query" image="error" description="参数错误" />
    <van-dialog
      v-model="show"
      title="请选择挂号方式"
      show-cancel-button
      confirmButtonColor="rgb(22,119,254)"
      @confirm="onConfirm"
      @cancel="closePopup"
    >
      <van-radio-group v-model="radio" @change="onRadioChange">
        <van-radio name="1" class="custom-radio">自费</van-radio>
        <van-radio name="2" class="custom-radio">医保</van-radio>
        <div class="ybTips">（仅占号，需线下窗口刷医保卡付款）</div>
      </van-radio-group>
    </van-dialog>
  </div>
</template>

<script>
import { createOrder, getDefaultPatient } from '@/api/api'
import { _date_ } from '../../utils/calculationDate'
import { Toast, Dialog, RadioGroup, Radio } from 'vant'
export default {
  name: 'payDetail',
  data() {
    return {
      query: null,
      patientsData: '',
      show: false,
      radio: ''
    }
  },
  created() {},
  mounted() {
    // this.getList()
    this.query = this.$route.query ? this.$route.query : null
    console.log(this.query, 'query')
  },
  methods: {
    // 获取就诊人
    getList() {
      getDefaultPatient().then(res => {
        if (res.code == 200) {
          this.patientsData = res.data[0]
        } else {
          console.error('获取就诊人失败')
        }
      })
    },
    dateProp(datecode) {
      return _date_(datecode)
    },
    goPay() {
      this.show = true
    },
    onConfirm() {
      let date = this.query.hyDate
      let year = date.slice(0, 4)
      let month = date.slice(5, 7)
      let day = date.slice(8, 10)
      let visitDate = year + '-' + month + '-' + day
      let data = {
        // amount: Number(this.$route.query.fee) * 100,
        // userPayStatus: '0',
        // status: '0',
        // patientId: this.$route.query.patientId,
        // patientName: this.$route.query.patientName,
        // sectionId: this.$route.query.sectionId,
        // sectionName: this.$route.query.sectionName,
        // doctorId: this.$route.query.doctorId,
        // doctorName: this.$route.query.doctorName,
        // orderType: '0',
        // visitTime: visittimeArr[1],
        // visitDate: visittimeArr[0],
        // sectionDoctorId: this.$route.query.sectionDoctorId,

        /** 出诊时间 时 分（由于鞍山HIS系统不提供具体时间点，如10:30，值提供如：上午、下午、白天、晚上 的相关编码，所以该字段根据具体使用情况判断）*/
        // visitTime: this.query.SESSION_CODE,
        /** HIS系统用于排班编码*/
        // hisOrderCode: this.query.ORDER_CODE,
        /** 交易金额 单位分 */
        amount: Number(this.query.totCost) * 100,
        /** 就诊人ID */
        patientId: this.query.patientId,
        /** 就诊人姓名 */
        patientName: this.query.patientName,
        /** 科室ID */
        sectionId: this.query.deptCode,
        /** 科室名称 */
        sectionName: this.query.deptName,
        /** 医生id */
        doctorId: this.query.doctCode,
        /** 医生名称 */
        doctorName: this.query.doctName,
        /** 出诊日期 年 月 日*/
        visitDate: visitDate,
        // 订单类型
        orderType: '0',
        // 诊室ID
        // clinicRoomNo: this.query.CLINICROOM_NO
        //
        scheduleId: this.query.hyId
      }
      if (this.radio === '1') {
        // 自费
        this.toOrder(data)
      } else if (this.radio === '2') {
        // 医保
        data.yb = true
        this.toOrder(data)
      }
    },
    toOrder(data) {
      console.log(data)
      createOrder(data).then(res => {
        if (data.yb) {
          if (res.code == 200 && res.msg == 'OK') {
            Dialog.alert({
              title: '提示',
              message: '挂号成功，请于就诊日在窗口付款'
            }).then(() => {
              // on close
              this.$router.push('/index')
            })
          } else if (res.code == 200 && res.msg == 'MEPAY') {
            Toast('已存在该挂号订单')
            this.$router.push({
              name: 'payList',
              query: {
                patientId: this.$route.query.patientId,
                patientName: this.$route.query.patientName
              }
            })
            return
          } else {
            Toast.fail(res.data || '未知错误')
            this.$router.go(-1)
          }
        } else {
          if (res.code == 200 && res.msg == 'OK') {
            this.$router.replace({
              name: 'goPay',
              params: res.data
            })
          } else if (res.code == 200 && res.msg == 'MEPAY') {
            Toast('已存在该挂号订单')
            this.$router.push({
              name: 'payList',
              query: {
                patientId: this.$route.query.patientId,
                patientName: this.$route.query.patientName
              }
            })
            return
          } else {
            Toast.fail(res.data || '未知错误')
            this.$router.go(-1)
          }
        }
      })
    },
    closePopup() {
      this.show = false
    },
    onRadioChange(value) {
      this.radio = value
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background: rgb(242, 248, 253);
}
.people {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);
  font-size: 18px;

  &-label {
    width: 100px;
    color: #666;
    display: flex;
    align-items: center;
  }
  &-text {
    width: calc(100% - 80px);
  }
}
.detail {
  width: 100%;
  display: flex;
  align-items: center;
  height: 38px;
  background: #fff;
  padding: 0 15px;
  font-size: 18px;

  &-label {
    width: 100px;
    color: #666;
    display: flex;
    align-items: center;
  }
  &-text {
    width: calc(100% - 70px);
  }
}
.pay-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);
  border-top: 1px solid rgb(234, 234, 234);
  font-size: 18px;
  &-label {
    display: flex;
    align-items: center;
  }
  &-text {
    color: rgb(237, 125, 84);
  }
}
.btn-box {
  width: 100%;
  padding: 0 15px;
  padding-top: 15px;
}
.btn-box button {
  font-size: 18px;
}
.btn-box .van-button--large {
  height: 48px;
}

@font-face {
  font-family: 'iconfont1';
  src: url('data:font/truetype;charset=utf-8;base64,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')
    format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.iconfont1 {
  font-family: 'iconfont1' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-user-wait:before {
  content: '\e6b2';
}
.custom-radio {
  margin: 10px 0 0 20px;
}
.ybTips {
  text-align: center;
  margin: 0 20px 10px 20px;
}
</style>
